/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { CatalogShowCatalogResponse } from "./CatalogShowCatalogResponse";

export type CatalogShowCatalogResponseApiRespoonse = {
  data?: CatalogShowCatalogResponse;
  status?: CatalogShowCatalogResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace CatalogShowCatalogResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
